<template>
  <div
    class="qna-session"
    :style="{ 'background-color': modalBackgroundColour}"
    :class="{'animate__zoomIn animate__animated animate__faster':
               $store.state.slideActive.type != 'question',
             'inside-slide': $store.state.slideActive.type == 'question',
             'qna-text-white': isTextColourLight}"
  >
    <h2 class="text-center">
      {{ $t("questionsFromAudience") }}
    </h2>
    <i class="fas fa-times" @click="closeQna()" />
    <div class="horizontal layout content-qna-session">
      <div class="left-column-qna">
        <ul>
          <li
            :class="{active: $store.state.tabQnaQuestion == 1}"
            @click="selectTab(1)"
          >
            {{ $t("topQuestions") }} <span
              class="question-count"
              v-if="$store.state.countTopQuestion"
            >({{ $store.state.countTopQuestion | formatTotalPoint }})</span>
          </li>
          <li :class="{active: $store.state.tabQnaQuestion == 2}" @click="selectTab(2)">
            {{ $t("pinnedQuestions") }} <span
              class="question-count"
              v-if="$store.state.countPinnedQuestion"
            >({{ $store.state.countPinnedQuestion | formatTotalPoint }})</span>
          </li>
          <li :class="{active: $store.state.tabQnaQuestion == 3}" @click="selectTab(3)">
            {{ $t("newestQuestions") }}
          </li>
          <li :class="{active: $store.state.tabQnaQuestion == 4}" @click="selectTab(4)">
            {{ $t("oldestQuestions") }}
          </li>
          <li :class="{active: $store.state.tabQnaQuestion == 5}" @click="selectTab(5)">
            {{ $t("answeredQuestions") }} <span
              class="question-count"
              v-if="$store.state.countAnswerQuestion"
            >({{ $store.state.countAnswerQuestion | formatTotalPoint }})</span>
          </li>
        </ul>
      </div>
      <div
        class="flex right-column-qna vertical layout"
        :class="{'no-allow-vote-count': !presentation.qnaAudienceShowAll}"
      >
        <div
          class="flex top-list"
          id="top-list-scroll"
          ref="top-list-scroll"
          @scroll="_scrollToBottom()"
        >
          <div class="text-left no-question">
            <p
              v-if="isShowModerationNotice"
            >
              <span v-if="!pendingQuestions">
                {{ $t("Question moderation is on.") }}
              </span>
              <span v-else-if="pendingQuestions === 1">
                {{ $t('question pending moderation.', {
                  number: pendingQuestions,
                }) }}
              </span>
              <span v-else>
                {{ $t('questions pending moderation.', {
                  number: pendingQuestions,
                }) }}
              </span>
              <span
                class="font-bold underline cursor-pointer"
                @click="handleTurnOffModeration"
              >{{ pendingQuestions ? $t("Show all") : $t("Turn off") }}</span>
              <span class="lowercase normal-spacing">{{ $t("or") }}</span>
              <span
                class="font-bold underline cursor-pointer"
                @click="handleOpenModeration"
              >{{ $t("Moderate here") }}</span>
              <i class="ml-1 text-xl fas fa-external-link-alt"></i>
            </p>
            <p v-if="!presentation.isModerationMode && noQuestionTerm">
              {{ $t(noQuestionTerm) }}
            </p>
          </div>

          <div
            v-for="(item, index) in $store.state.questions"
            :key="index"
            @click="selectQuestion(item.id)"
            :id="'qna-item-question-' + item.id"
          >
            <div
              class="item-qna"
              v-show="checkShowQuestion(item)"
              :class="{'item-qna-selected': item.id == activeQuestion}"
            >
              <div class="question-info horizontal layout">
                <div class="flex horizontal layout center">
                  <div class="avatar">
                    <div
                      class="default-ava horizontal layout center center-justified"
                      v-if="!item.audienceName"
                    >
                      <i class="fas fa-user" />
                    </div>
                    <div
                      class="color-ava"
                      v-if="item.audienceName"
                      :style="{ 'background-color': item.audienceColor}"
                    >
                      {{ item.audienceName | textAvatar }}
                    </div>
                  </div>
                  <div class="name-audience">
                    <div>
                      <span class="inline-block max-w-52 align-bottom truncate" v-if="item.audienceName">
                        {{ item.audienceName | profanity }}
                      </span>
                      <span v-if="!item.audienceName">Anonymous</span>
                      <span class="time-post">{{ item.createdAt | dateTimeAgoQuestion }}</span>
                    </div>
                  </div>
                </div>

                <div class="action-question horizontal layout center">
                  <aha-antd-button
                    variant="primary"
                    size="sm"
                    class="item-action item-answered"
                    v-if="!item.answered && $store.state.tabQnaQuestion != 5"
                    @click.stop="answerQuestion(item, index)"
                  >
                    <i class="far fa-check-circle" />
                    <span>{{ $t("markAsAnswered") }}</span>
                  </aha-antd-button>
                  <ButtonStartVoice
                    class="button-voice item-action"
                    v-if="item.audience"
                    :audienceUnique="item.audience"
                    :audienceName="item.audienceName"
                  />
                  <aha-antd-button
                    variant="secondary"
                    size="sm"
                    class="item-action item-pinned"
                    v-if="!item.answered"
                    @click.stop="pinQuestion(item, index)"
                    :class="{primary: item.pinned}"
                  >
                    <i class="fas fa-thumbtack" />
                    <span v-if="!item.pinned">{{ $t("pinButton") }}</span>
                    <span v-if="item.pinned">{{ $t("pinnedQuestions") }}</span>
                  </aha-antd-button>
                  <div
                    class="item-action item-like"
                    v-if="presentation.qnaAudienceShowAll == 'true' ||
                      presentation.qnaAudienceShowAll === true"
                  >
                    <span>{{ item.voteCount }}</span>
                    <i class="fas fa-thumbs-up" />
                  </div>
                </div>
              </div>
              <div class="question-content">
                <p>{{ item.title | profanity }} </p>
              </div>
            </div>
          </div>
        </div>
        <!-- Back to top btn -->
        <div
          v-show="!presentation.isModerationMode"
          class="top-list-btn"
          :class="{'top-questions': $store.state.tabQnaQuestion == 1}"
        >
          <aha-antd-button
            variant="secondary"
            size="md"
            @click.stop="handleBackToTopButtonClick()"
            :class="{'show': showBackToTopBtn}"
          >
            <i class="pr-2 fas fa-arrow-up fa-fw" />{{ $t('Back to top') }}
          </aha-antd-button>
        </div>

        <div
          class="new-item"
          v-if="$store.state.tabQnaQuestion == 1 && $store.state.lastQuestion.id && $store.state.questionCount > 3"
        >
          <div class="text-center title-new-item">
            {{ $t("latestQuestion") }}
          </div>
          <div class="item-qna">
            <div class="question-info horizontal layout">
              <div class="flex horizontal layout center">
                <div class="avatar">
                  <div
                    class="default-ava horizontal layout center center-justified"
                    v-if="!$store.state.lastQuestion.audienceName"
                  >
                    <i class="fas fa-user" />
                  </div>
                  <div
                    class="color-ava"
                    v-if="$store.state.lastQuestion.audienceName"
                    :style="{ 'background-color': $store.state.lastQuestion.audienceColor}"
                  >
                    {{ $store.state.lastQuestion.audienceName | textAvatar }}
                  </div>
                </div>
                <div class="name-audience">
                  <div>
                    <span
                      v-if="$store.state.lastQuestion.audienceName"
                    >{{ $store.state.lastQuestion.audienceName | profanity }}</span>
                    <span v-if="!$store.state.lastQuestion.audienceName">Anonymous</span>
                    <span
                      class="time-post"
                    >{{ $store.state.lastQuestion.createdAt | dateTimeAgoQuestion }}</span>
                  </div>
                </div>
              </div>
              <div class="action-question horizontal layout center">
                <aha-antd-button
                  variant="text"
                  size="sm"
                  class="item-action item-answered"
                  @click.stop="answerLastestQuestion()"
                >
                  <i class="far fa-check-circle" />
                  <span>{{ $t("markAsAnswered") }}</span>
                </aha-antd-button>

                <aha-antd-button
                  variant="text"
                  size="sm"
                  class="item-action item-pinned"
                  @click.stop="pinLatestQuestion()"
                  :class="{primary: $store.state.lastQuestion.pinned}"
                >
                  <i class="fas fa-thumbtack" />
                  <span v-if="!$store.state.lastQuestion.pinned">{{ $t("pinButton") }}</span>
                  <span v-if="$store.state.lastQuestion.pinned">{{ $t("pinnedQuestions") }}</span>
                </aha-antd-button>

                <div
                  class="item-action item-like"
                  v-if="presentation.qnaAudienceShowAll == 'true' ||
                    presentation.qnaAudienceShowAll === true"
                >
                  <span>{{ $store.state.lastQuestion.voteCount }}</span>
                  <i class="fas fa-thumbs-up" />
                </div>
              </div>
            </div>
            <div class="question-content">
              <p>{{ $store.state.lastQuestion.title | profanity }} </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Util from '@/util'
import Config from '@/config'
import socket from '@/socket'
import eventCategories from '@/constant/eventCategories'
import EventBus from '@/eventBus'

import PresentationApi from '@/api/presentation'

import ButtonStartVoice from '@/components-v2/voice-audio/ButtonStartVoice.vue'

export default {
  components: {
    ButtonStartVoice,
  },
  data() {
    return {
      topQuestions: [],
      activeQuestion: null,
      showBackToTopBtn: false,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      questions: (state) => state.questions,
      tabQnaQuestion: (state) => state.tabQnaQuestion,
      countTopQuestion: (state) => state.countTopQuestion,
      countPinnedQuestion: (state) => state.countPinnedQuestion,
      countAnswerQuestion: (state) => state.countAnswerQuestion,
    }),
    ...mapGetters(['isTextColourLight']),
    ...mapGetters('slideModule', ['modalBackgroundColour']),
    pendingQuestions() {
      if (this.questions && this.presentation.isModerationMode) {
        return this.questions.filter(
          (item) => item.status !== 'approved' && item.status !== 'dismissed',
        ).length
      }

      return 0
    },
    noQuestionTerm() {
      /** Tabs
       * Top questions: 1
       * Pinned: 2
       * Newest: 3
       * Oldest: 4
       * Answered: 5
       */

      if ([1, 3, 4].includes(this.tabQnaQuestion) && !this.countTopQuestion) {
        return 'noUnansweredQuestions'
      }

      if (this.tabQnaQuestion == 2 && !this.countPinnedQuestion) {
        return 'noUnansweredPinnedQuestions'
      }

      if (this.tabQnaQuestion == 5 && !this.countAnswerQuestion) {
        return 'noAnsweredQuestion'
      }

      return ''
    },
    isShowModerationNotice() {
      return this.tabQnaQuestion !== 5
        && !this.countTopQuestion
        && this.presentation.isModerationMode
    },
  },
  mounted() {
    EventBus.$on('slide-qr-scroll', (keyCode) => {
      const scrollableDiv = this.$refs['top-list-scroll']
      if (keyCode === 'ArrowUp') {
        scrollableDiv.scrollTo({
          top: scrollableDiv.scrollTop - 120,
          behavior: 'smooth',
        })
      } else if (keyCode === 'ArrowDown') {
        scrollableDiv.scrollTo({
          top: scrollableDiv.scrollTop + 120,
          behavior: 'smooth',
        })
      }
    })
  },

  destroyed() {
    EventBus.$off('slide-qr-scroll')
  },

  methods: {
    ...mapActions(['setSyncLoadingAction']),
    selectQuestion(id) {
      if (this.activeQuestion != id) {
        this.activeQuestion = id
      }
    },
    checkShowQuestion(item) {
      if (this.presentation.isModerationMode && item.status !== 'approved') return false
      if (
        this.$store.state.tabQnaQuestion === 1 ||
        this.$store.state.tabQnaQuestion === 3 ||
        this.$store.state.tabQnaQuestion === 4
      ) {
        if (item.answered || item.status === 'dismissed') return false
      }
      if (this.$store.state.tabQnaQuestion === 2) {
        if (!item.pinned || item.answered || item.status === 'dismissed') return false
      }
      if (this.$store.state.tabQnaQuestion === 5) {
        if (!item.answered || item.status === 'dismissed') return false
      }
      return true
    },
    selectTab(index) {
      this.$store.state.tabQnaQuestion = index
      const arr = JSON.parse(JSON.stringify(this.$store.state.questions))
      Util.updateDataQuestionAnswer(arr, this.$store.state.tabQnaQuestion)
    },
    closeQna() {
      this.$store.state.showQnaSession = false
    },
    pinQuestion(item, index) {
      if (this.$store.state.sharePresentation) return
      item.pinned = !item.pinned
      this.$store.state.questions[index].pinned = item.pinned
      const payload = {
        id: item.id,
        presentationId: this.presentation.id,
        pinned: item.pinned,
        audience: item.audience,
      }
      const arr = JSON.parse(JSON.stringify(this.$store.state.questions))
      Util.updateDataQuestionAnswer(
        arr,
        this.$store.state.tabQnaQuestion,
      )
      if (item.pinned) {
        this.activeQuestion = item.id
        setTimeout(() => {
          const el = document.getElementById(`qna-item-question-${item.id}`)

          if (el && el.offsetTop < 20) {
            const options = {
              top: el.offsetTop,
              behavior: 'smooth',
            }

            Util.scrollToElement(document.getElementById('top-list-scroll'), options)
          }
        }, 200)
      }
      this._updateQuestion(payload)

      if (this.$store.state.lastQuestion.id == item.id) {
        this.$store.state.lastQuestion.pinned = item.pinned
      }

      if (item.pinned) {
        Util.mixpanelTracking(
          'Question And Answer',
          'Question Updated',
          'Question Pinned',
        )
      } else {
        Util.mixpanelTracking(
          'Question And Answer',
          'Question Updated',
          'Question Unpinned',
        )
      }
    },

    pinLatestQuestion() {
      if (this.$store.state.sharePresentation) return
      this.$store.state.lastQuestion.pinned = !this.$store.state.lastQuestion
        .pinned
      const index = this.$store.state.questions.findIndex((item) => {
        return item.id == this.$store.state.lastQuestion.id
      })
      this.$store.state.questions[
        index
      ].pinned = this.$store.state.lastQuestion.pinned
      const arr = JSON.parse(JSON.stringify(this.$store.state.questions))
      Util.updateDataQuestionAnswer(
        arr,
        this.$store.state.tabQnaQuestion,
      )
      const payload = {
        id: this.$store.state.lastQuestion.id,
        presentationId: this.presentation.id,
        pinned: this.$store.state.lastQuestion.pinned,
        audience: this.$store.state.lastQuestion.audience,
      }
      this._updateQuestion(payload)
      if (this.$store.state.lastQuestion.pinned) {
        Util.mixpanelTracking(
          'Question And Answer',
          'Question Updated',
          'Question Pinned',
        )
      } else {
        Util.mixpanelTracking(
          'Question And Answer',
          'Question Updated',
          'Question Unpinned',
        )
      }
    },
    answerQuestion(item, index) {
      if (this.$store.state.sharePresentation) return
      this.$store.state.questions[index].answered = true
      this.$store.state.questions[index].status = 'approved'
      this.$store.state.questions[
        index
      ].answeredTimestamp = new Date().getTime()
      const payload = {
        id: item.id,
        presentationId: this.presentation.id,
        answered: true,
        audience: item.audience,
        status: 'approved',
      }
      this._updateQuestion(payload)
      const arr = JSON.parse(JSON.stringify(this.$store.state.questions))
      Util.updateDataQuestionAnswer(arr, this.$store.state.tabQnaQuestion)
      Util.mixpanelTracking(
        'Question And Answer',
        'Question Updated',
        'Question Answered',
      )
    },

    answerLastestQuestion() {
      if (this.$store.state.sharePresentation) return
      const index = this.$store.state.questions.findIndex((item) => {
        return item.id == this.$store.state.lastQuestion.id
      })
      this.$store.state.questions[index].answered = true
      this.$store.state.questions[index].status = 'approved'
      this.$store.state.questions[
        index
      ].answeredTimestamp = new Date().getTime()
      const arr = JSON.parse(JSON.stringify(this.$store.state.questions))
      Util.updateDataQuestionAnswer(
        arr,
        this.$store.state.tabQnaQuestion,
      )
      const payload = {
        id: this.$store.state.lastQuestion.id,
        presentationId: this.presentation.id,
        answered: true,
        audience: this.$store.state.lastQuestion.audience,
        status: 'approved',
      }
      this._updateQuestion(payload)
    },
    _updateQuestion(payload) {
      payload.socketId = socket.getSocketId()

      this.$http
        .put(Config.api.updateQuestion + payload.id, payload)
        .then(() => {
          return true
        })
        .catch(() => {
          return false
        })
    },
    _scrollToBottom() {
      const topList = this.$refs['top-list-scroll']
      // Check if has scroll
      if (topList.clientHeight < topList.scrollHeight) {
        this.showBackToTopBtn = true
      }
      if (topList.scrollTop == 0) {
        this.showBackToTopBtn = false
      }
    },
    handleBackToTopButtonClick() {
      const options = { top: 0, behavior: 'smooth' }
      Util.scrollToElement(this.$refs['top-list-scroll'], options)
    },

    handleOpenModeration() {
      Util.mixpanelTracking(
        this.$store.getters.isPresenting
          ? eventCategories.PRESENTING_MODE
          : eventCategories.PRESENTATION_EDITOR,
        'Q&A Moderation > Open the Q&A moderation page',
      )
      window.open(
        `${Config.backstageDomain}/${this.presentation.moderationCode}`,
        '_blank',
      )
    },

    async handleTurnOffModeration() {
      try {
        await PresentationApi.updatePresentationByPresentationId(this.presentation.id, {
          isModerationMode: false,
        })
        this.presentation.isModerationMode = false
        Util.updateDataQuestionAnswer(this.$store.state.questions,
          this.$store.state.tabQnaQuestion)
        Util.mixpanelTracking(
          this.$store.getters.isPresenting
            ? eventCategories.PRESENTING_MODE
            : eventCategories.PRESENTATION_EDITOR,
          'Q&A Moderation > Turn off',
          'Unchecked',
        )
      } catch (error) {
        this.setSyncLoadingAction(3)

        if (error.status) {
          throw error
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.question-info {
    margin-bottom: 4px;
}
.no-question {
  p {
    font-size: 26px;
  }
}
.question-count {
  font-size: 16px;
  opacity: 0.7;
  margin-left: 4px;
}
.avatar {
  .default-ava,
  .color-ava {
    background-color: $primary-color;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border-radius: 50%;
    margin-right: 8px;
    margin-bottom: 4px;
    margin-top: 4px;
    border: 1px solid #fff;

    i {
      color: #fff;
      font-size: 14px;
    }
  }

  .color-ava {
    color: #fff;
    text-transform: uppercase;
    font-size: 13px;
    font-weight: bold;
  }
}

.right-column-qna {
  position: relative;
  .top-list {
    overflow: hidden;
    overflow-y: auto;
    -ms-overflow-style: auto;
  }
}

.content-qna-session {
  height: 505px;
}
.item-qna {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  padding: 12px 16px 18px;
  margin: 2px 10px 16px 2px;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.1);
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.075);
  .action-question {
    position: absolute;
    top: 12px;
    right: 16px;
    font-size: 20px;
    opacity: 0.8;
    .item-action {
      cursor: pointer;
      margin-left: 8px;
      transition: opacity 0.25s;
      backface-visibility: hidden;

      &.item-answered, &.item-pinned {
        opacity: 0;
        font-size: 14px;

        i {
          margin-right: 6px;
        }
      }

      &.item-like {
        padding: 5px 0 3px;
        min-width: 48px;
        text-align: right;
      }

      &.primary {
        opacity: 1;
      }

      i {
        margin-right: 4px;
      }

      .fa-thumbs-up {
        margin-left: 4px;
      }
    }

  }

  &.item-qna-selected {
    border: 3px solid $primary-color;
    margin: 2px 8px 12px 2px;
    top: -2px;
    left: -2px;

    .action-question {
      right: 14px;
    }
  }

  &:hover {
    cursor: pointer;
    .item-action {
      &.item-answered, &.item-pinned, &.button-voice {
        opacity: 1;
      }

    }
  }
}

.qna-text-white {
  .item-qna {
    background-color: rgba(255, 255, 255, 0.2);

    &.item-qna-selected {
      border-color: #fff;
    }

    .item-action  {
      &.item-answered, &.item-pinned {
        border-color: rgba(255, 255, 255, 0.4)
      }
    }
  }
}

.time-post {
  font-size: 15px;
  opacity: 0.7;
  line-height: 15px;
  margin-left: 8px;
}

.qna-session {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  padding: 24px;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.2);
  padding-right: 14px;
  user-select: text;

  &.zoomIn {
    .top-list-btn.top-questions {
      bottom: 190px;
    }
  }

  .top-list-btn {
    width: 96%;
    text-align: right;
    position: absolute;
    bottom: 10px;
    transition: .2s ease-in-out;
    z-index: 15;
    &.top-questions {
      bottom: 167px;
    }

    ::v-deep .aha-antd-button {
      box-shadow: none;
      cursor: default;
      display: inline-block;
      visibility: hidden;

      &.show {
        visibility: visible;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }

  .fa-times {
    position: absolute;
    top: 12px;
    right: 16px;
    font-size: 30px;
    cursor: pointer;
  }
  .question-content {
    line-height: 1.3;

    p {
      margin-bottom: 0;
      font-size: 24px;
      white-space: pre-wrap;
      word-break: break-word;
      cursor: default;
      -webkit-user-select: text;
      -khtml-user-select: text;
      -moz-user-select: text;
      -o-user-select: text;
      user-select: text;
    }
  }
}

.new-item {
  margin-bottom: 8px;
  .title-new-item {
    margin-bottom: 8px;
    margin-top: 16px;
  }

  .question-content {
    p {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* number of lines to show */
      -webkit-box-orient: vertical;
    }
  }
}

h2 {
  font-size: 40px;
  margin-bottom: 16px;
}
.name-audience {
  font-size: 18px;
  opacity: 0.8;
}

.left-column-qna {
  padding-right: 16px;
  width: 250px;

  ul {
    padding-left: 0;
    li {
      list-style: none;
      padding: 8px 16px;
      cursor: pointer;
      font-size: 20px;
      transition: background-color 0.2s;
      opacity: 0.8;
      border-left: 3px solid transparent;

      &.active {
        opacity: 1;
        font-weight: bold;
        border-color: $primary-color;
      }
    }
  }
}

.inside-slide {
  padding: 16px 58px 0 60px;
  background-color: transparent !important;
  box-shadow: none;
  border-radius: 0;
  .new-item {
    margin-bottom: 0;
    .item-qna {
      margin-bottom: 0;
    }
  }

  h2,
  .fa-times {
    display: none;
  }

  .content-qna-session {
    height: auto;
    -ms-flex: 1 1 0;
    -webkit-box-flex: 1;
    flex: 1;
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
  }

  &.qna-session {
    -ms-flex-direction: column;
    -moz-flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    display: -ms-flexbox;
    display: -moz-flex;
    display: -webkit-box;
    display: flex;
  }
}

.no-allow-vote-count {
  .fa-check-circle {
    right: 54px !important;
  }
}

.button-voice {
  margin-left: 8px;
  opacity: 0;
}

.normal-spacing {
  margin-left: 0.25em;
  margin-right: 0.25em;
}
</style>
